import { Metric } from '../../../../dashboard-config/dashboard-config.model';
import {
  expandProductCatalog,
  ProductCatalogEntry,
} from '../../../_shared/dashboard-definition.model';
import { createDashboardDossierStatesDefinition } from '../create-dossier-states-definition';
import { DossierShell } from '../dossier-shell.profile';
import {
  DossierMarketMetricProfile,
  dossierMarketEconomicParticipantProfile,
  dossierMarketEmployedProfile,
  dossierMarketGvaProfile,
  dossierMarketRevenueProfile,
  dossierMarketTaxedProfile,
} from './dashboard-dossier-states-market-metric.profile';
import { DashboardDossierStatesMarketDefinition } from './dashboard-dossier-states-market.definition';

/**
 * Product catalog for dossier states market (branchenstruktur).
 * Identity is derived in {@link createDashboardDossierStatesDefinition}.
 */

// Pending datasets: Tourism and SelfEmployed dossiers.
type DossierMarketMetric = Exclude<Metric, Metric.Tourism | Metric.SelfEmployed>;

export const DOSSIER_STATES_MARKET_PRODUCT_CATALOG: Record<
  DossierMarketMetric,
  ProductCatalogEntry<DossierMarketMetricProfile, DossierShell>
> = {
  [Metric.CompaniesCount]: {
    metric: dossierMarketTaxedProfile,
    shells: ['market'],
  },
  [Metric.CompaniesRevenue]: {
    metric: dossierMarketRevenueProfile,
    shells: ['market'],
  },
  [Metric.GrossValueAdded]: {
    metric: dossierMarketGvaProfile,
    shells: ['market'],
  },
  [Metric.EconomicParticipant]: {
    metric: dossierMarketEconomicParticipantProfile,
    shells: ['market'],
  },
  [Metric.Employed]: {
    metric: dossierMarketEmployedProfile,
    shells: ['market'],
  },
};

/** All dossier states market (branchenstruktur) product definitions. */
export const DOSSIER_STATES_MARKET_DEFINITIONS: DashboardDossierStatesMarketDefinition[] =
  expandProductCatalog(
    Object.values(DOSSIER_STATES_MARKET_PRODUCT_CATALOG),
    createDashboardDossierStatesDefinition,
  );
